export interface FiscalYearRange {
  fiscal_year_label: string;
  fiscal_year_start_year: number;
  from_date: string;
  to_date: string;
}

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function getFiscalYearStartYear(fyStartMonth: number, asOf: Date = new Date()): number {
  const month = asOf.getMonth() + 1;
  const year = asOf.getFullYear();
  return month >= fyStartMonth ? year : year - 1;
}

export function getFiscalYearRange(fyStartMonth: number, fiscalYearStartYear: number): FiscalYearRange {
  const startMonth = Math.min(12, Math.max(1, fyStartMonth));
  const from_date = `${fiscalYearStartYear}-${pad2(startMonth)}-01`;

  let endYear: number;
  let endMonth: number;
  if (startMonth === 1) {
    endYear = fiscalYearStartYear;
    endMonth = 12;
  } else {
    endYear = fiscalYearStartYear + 1;
    endMonth = startMonth - 1;
  }
  const lastDay = new Date(endYear, endMonth, 0).getDate();
  const to_date = `${endYear}-${pad2(endMonth)}-${pad2(lastDay)}`;

  return {
    fiscal_year_label: `FY${fiscalYearStartYear}`,
    fiscal_year_start_year: fiscalYearStartYear,
    from_date,
    to_date,
  };
}

export function formatFiscalYearPeriodLabel(range: FiscalYearRange): string {
  const [fromY, fromM] = range.from_date.split('-').map(Number);
  const [toY, toM] = range.to_date.split('-').map(Number);
  return `${range.fiscal_year_label} (${MONTH_NAMES[fromM - 1]} ${fromY} – ${MONTH_NAMES[toM - 1]} ${toY})`;
}
